import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, MenuItem, SelectItem, TreeNode } from 'primeng/components/common/api';
import { Utils } from '../../../../../utils';
import { EmailService } from '../_service/EmailService';
import { Email } from '../_model/Email';
import { query } from '@angular/animations/src/animation_metadata';
import { GenericComponent } from '../../../../layouts/custom-component/generic-component';
import { PageTableComponent } from '../../../../layouts/custom-component/page-table.component';
import { PulsanteService } from '../_service/PulsanteService';
import { Tipo_mailService } from '../_service/Tipo_mailService';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: './mail.component.html',

    providers: [
        EmailService, { provide: String, useValue: "EmailAF" },
        PulsanteService,
        Tipo_mailService
    ]



    //providers: [EmailService]

})
export class MailComponent extends PageTableComponent implements OnInit {

    tipologia: SelectItem[];
    item: Email;
    itemName: string;
    cols: any[];
    loadTableStr: string;
    genericform: FormGroup;

    pulsantiList: SelectItem[];

    constructor(private fb: FormBuilder, private es: EmailService, private ps: PulsanteService, private ts: Tipo_mailService) {
        super(es);
    }

    ngOnInit() {



        this.loading = true;
        this.ps.getAll().then((retdata) => {

            this.loading = false;
            if (retdata.response == 0) {

                this.pulsantiList = [];
                retdata.data.pulsanteList.forEach(pulsante => {
                    this.pulsantiList.push({ label: pulsante.nome, value: pulsante.id });
                });
            } else {
                this.showMessageError(retdata);
            }
        })

        this.ts.getAll().then((retdata) => {
            Utils.log("TS_GET_ALL: ", retdata);

            if (retdata.response == 0) {

                this.tipologia = [];
                this.tipologia.push({ label: "Seleziona Tipologia", value: "" });

                retdata.data.tipo_mailList.forEach(tipo => {
                    this.tipologia.push({ label: tipo.nome, value: tipo.id });
                });
            } else {
                this.showMessageError(retdata);
            }
        })

        this.item = new Email();
        this.itemName = "email";

        this.cols = [
            { field: 'id', header: 'id', sortable: false },
            { field: 'mittente', header: 'Mittente', sortable: false },
            { field: 'cc', header: 'CC', sortable: false },
            { field: 'oggetto', header: 'Oggetto', sortable: false },
            { field: 'progressivo', header: 'Progressivo', sortable: false },
            //{ field: 'punti', header: 'Punti', sortable: true },
            { field: 'tipoStr', header: 'Tipo', sortable: true }
        ];

        this.genericform = this.fb.group({
            'id': new FormControl(''),
            'mittente': new FormControl('', Validators.required),
            'cc': new FormControl(''),
            'oggetto': new FormControl(''),
            'progressivo': new FormControl('', Validators.required),
            'testo': new FormControl(''),
            //'punti': new FormControl('', Validators.required),
            "tipo_id": new FormControl('', Validators.required),
            "tipo_id1": new FormControl(''),
            "tipo_id2": new FormControl(''),
            //"pulsanti": new FormControl('', Validators.required)
        });
    }
}





// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/home/mail.component.ts